var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useFormContext } from "react-hook-form";
import { useDebouncedValidation } from "../../utility/useDebouncedValidation";
import { RadixInput } from "../../primitives/RadixInput";
export var AddressField = function (props) {
    var _a = useFormContext(), register = _a.register, errors = _a.formState.errors, trigger = _a.trigger;
    var debouncedTrigger = useDebouncedValidation(trigger);
    var _b = register("address"), ref = _b.ref, onBlur = _b.onBlur, onChange = _b.onChange, name = _b.name;
    return (React.createElement("div", { className: "radix-form-field" },
        React.createElement(RadixInput, __assign({ id: "avsAddress", name: name, ref: ref, onBlur: onBlur, onChange: function (event) {
                onChange(event);
                debouncedTrigger("address");
            }, placeholder: "Street Number and Name*", "aria-invalid": !!errors.address, "aria-describedby": errors.address ? "avsAddress-error" : undefined, "aria-label": "Street Number and Name", autoComplete: "billing street-address" }, props)),
        errors.address && (React.createElement("span", { id: "avsAddress-error", className: "radix-error-message" },
            React.createElement("i", { className: "fas fa-exclamation-circle" }),
            " ",
            errors.address.message))));
};
